// export {FFmpeg, fetchFile, toBlobURL};
import {Platform} from 'react-native';
import {EncoderProject, Media} from '../../types';
import {getFileOpfs, writeFileOpfs} from '../fs';
import {FFmpegKit} from 'ffmpeg-kit-react-native';
import {getById, writeItem} from '../db';
import {getBase64} from '../util';
import {genRenderCmd as genRenderCmdExport} from './util/genRenderCmd';
import {genPreviewFromVideoCmd} from './util/genPreviewFromVideo';
import {genVideoFromImageCmd} from './util/genVideoFromImage';
import {genExecTime as genExecTimeExport} from './util/genExecTime';
import {genSpectroGramScript} from './util/genSpectroGram';
export const genExecTime = genExecTimeExport;
export const genRenderCmd = genRenderCmdExport;
const cachedMedia: {[key: string]: string} = {};

import {FileSystem} from 'react-native-file-access';

import {ffmpeg, createFFmpeg, fetchFile} from './ffmpeg';
export * from './rendering';
export * from './editor';

export const getPreviewFromVideo = async (nmedia: Media) => {
  const media = await getById(nmedia.id);
  const opfsFile = await getFileOpfs(media);
  const fileId = `${media.id}_${media?.filename}`;
  try {
    if (Platform.OS === 'web') {
      const input = fileId;
      const output = input + '.jpeg';
      const cmd = genPreviewFromVideoCmd({
        input,
        output,
        width: media.width,
        height: media.height,
      });
      await createFFmpeg(() => {});
      const fs = await fetchFile(opfsFile);
      await ffmpeg.writeFile(fileId, fs);

      console.info('after loading files into ffmpeg', cmd);
      const exec = await ffmpeg.exec(cmd);
      console.info('after exec', exec, output);
      const data = await ffmpeg.readFile(output);
      console.info('after processing', data);
      data.name = output;
      const file = await (
        (await writeFileOpfs(media, data)) as FileSystemFileHandle
      )?.getFile();
      media.image = (await getBase64(file)) as string;
      await writeItem(media);
      return media.image;
    } else {
      const input = opfsFile?.replace('file://', '') as string;

      const output = input + '.png';
      const cmd = genPreviewFromVideoCmd({
        input,
        output,
        width: media.width,
        height: media.height,
      });
      console.info('cmd', cmd);
      await new Promise(async r => {
        const exec = await FFmpegKit.executeAsync(
          cmd.join(' '),
          async () => {
            console.info('after exec cmd', exec);
            // setTimeout(async () => {
            try {
              media.image =
                'data:image/jpeg;base64,' +
                (await FileSystem.readFile(output, 'base64'));
              await writeItem(media);
            } catch (err) {
              media.image = output;
              await writeItem(media);
              console.error('preview for image save error', err);
            }
            r(true);
            // }, 1000);
          },
        );
      });
      return media.image;
    }
  } catch (err) {
    console.error('generate video from image err', err);
  }
};

export const generateVideoForImage = async (
  media: EncoderProject,
) => {
  console.info('generate video for image', media.filename);
  const fileId = `${media.id}_${media?.filename}`;
  const outFileId = media?.filename + '.mp4';
  const opfsFile = await getFileOpfs(media);
  console.info(' opfsFile', opfsFile);
  try {
    if (Platform.OS === 'web') {
      await createFFmpeg(() => {});
      const fs = await fetchFile(opfsFile);
      await ffmpeg.writeFile(fileId, fs);
      const cmd = genVideoFromImageCmd({
        input: fileId,
        width: media.encoding.width,
        height: media.encoding.height,
        output: outFileId,
      });

      console.info('after loading files into ffmpeg', cmd);
      const exec = await ffmpeg.exec(cmd);
      console.info('after exec', exec, outFileId);
      const data = await ffmpeg.readFile(outFileId);
      console.info('after processing', data);
      data.name = outFileId;
      const file = await (
        (await writeFileOpfs(media, data)) as FileSystemFileHandle
      )?.getFile();
      cachedMedia[media.id] = URL.createObjectURL(file);
      console.info('cachedMedia for project', cachedMedia[media.id]);
      return cachedMedia[media.id];
    }
    const output = opfsFile?.replace('file://', '') + '.mp4';
    const cmd = genVideoFromImageCmd({
      input: opfsFile?.replace('file://', '') as string,
      width: media.encoding.width,
      height: media.encoding.height,
      output,
    });
    console.info('cmd', cmd);
    return await new Promise(resolve => {
      FFmpegKit.executeAsync(cmd.join(' '), res => {
        // console.info
        console.info('after exec ffmpeg', res);
        resolve(output);
      });
    });
  } catch (err) {
    console.error('generate video from image err', err);
  }
};

export const generateAudioSpectrogram = async (
  nmedia: EncoderProject,
  size: 'big' | 'small' = 'big',
) => {
  const media = await getById(nmedia.id);
  console.info('generate spectrogram for media', media.filename);
  const fileId = `${media.id}_${media?.filename}`;
  const opfsFile = await getFileOpfs(media);
  // console.info(' opfsFile', opfsFile);
  const scaleFactor = size === 'big' ? 2 : 128;
  const width = parseInt(
    media?.duration && media.duration * scaleFactor,
    10,
  );
  try {
    if (Platform.OS === 'web') {
      const input = fileId;
      const output = `${input}.${size}.spectro.png`;
      await createFFmpeg(() => {});
      const fs = await fetchFile(opfsFile);
      await ffmpeg.writeFile(input, fs);
      const cmd = genSpectroGramScript(input, output, width);

      console.info('after loading files into ffmpeg', cmd);
      const exec = await ffmpeg.exec(cmd);
      console.info('after exec', exec, output);
      const data = await ffmpeg.readFile(output);
      console.info('after processing', data);
      data.name = output;
      const file = await (
        (await writeFileOpfs(media, data)) as FileSystemFileHandle
      )?.getFile();
      media[`audioSpectrogram_${size}`] = (await getBase64(
        file,
      )) as string;
      await writeItem(media);
      return media[`audioSpectrogram_${size}`];
    }
    const input = opfsFile?.replace('file://', '') as string;
    const output = `${input}.${size}.spectro.png`;
    const cmd = genSpectroGramScript(input, output, width);
    console.info('cmd', cmd);
    return await new Promise(resolve => {
      FFmpegKit.executeAsync(cmd.join(' '), async exec => {
        console.info('after exec cmd', exec);
        try {
          media[`audioSpectrogram_${size}`] =
            'data:image/png;base64,' +
            (await FileSystem.readFile(output, 'base64'));
          await writeItem(media);
        } catch (err) {
          media[`audioSpectrogram_${size}`] = output;
          await writeItem(media);
          console.error('generate spectrogram save error', err);
        }
        resolve(true);
      });
    });
  } catch (err) {
    console.error('generate spectrogram error', err);
  }
};
